export default "__VITE_ASSET__Z_q$DHQE__"